import useClipboard from 'vue-clipboard3';

const { toClipboard } = useClipboard();

const copyText = async (text, successCb) => {
  toClipboard(text)
    .then(successCb)
    .catch((reason) => {
      console.error(reason);
    })
  ;
};

export default copyText;
